import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { SessionType } from './session-type';

const stringToSessionTypeArray = z.codec(z.string(), z.array(z.enum(SessionType)), {
  decode: (sessionTypes) => sessionTypes.split(',') as SessionType[],
  encode: (sessionTypes) => sessionTypes.join(','),
});

export type SessionsQuery = z.output<typeof sessionsQuerySchema>;
export type SessionsQueryDTO = z.input<typeof sessionsQuerySchema>;

export const sessionsQuerySchema = z.object({
  from: isoDatetimeToDate,
  sessionTypes: stringToSessionTypeArray.optional(),
  to: isoDatetimeToDate,
});
